import React from "react";
import { graphql } from "react-apollo";
import { flowRight as compose } from "lodash";
import gql from "graphql-tag";
import {connect} from "react-redux";
import Form from "../../components/forms/ConfirmForm";
import {cancelRetryPayment} from "../../actions/AccountApiActions";
import {createValidationErrors, createErrors} from "../../lib/ErrorFormatter";

class RetryPaymentFormContainer extends React.Component {

  constructor(props) {
    super(props);
    this.state = { errors: [] }
  }

  handleSubmit() {
    return this.props.retryPayment({salesOrderId: this.props.salesOrderId})
      .then((response) => {
        if (response.data.retryPayment.errors.length <= 0) {
          this.props.cancelRetryPayment();
        } else {
          let errors = createValidationErrors(response.data.retryPayment.errors);
          this.setState({errors: errors});
        }
      })
      .catch((err) => {
        this.setState({errors: createErrors(err)});
      });      
  }

  handleCancel() {
    this.props.cancelRetryPayment();
  }

  render() {
    return (
      <Form
        errors={this.state.errors}
        message="An attempt will be made to retry stripe payment. Would you like to proceed?"
        onSubmit={this.handleSubmit.bind(this)}
        onCancel={this.handleCancel.bind(this)}
        />
    )
  }

}


const RETRY_PAYMENT = gql`
  mutation retryPayment($salesOrderId: ID!) {
    retryPayment(salesOrderId: $salesOrderId) {
      errors { key message }
    }
  }
`;

const withQueries = compose(
  graphql(RETRY_PAYMENT, {
    props: ({ mutate }) => ({
      retryPayment: (data) => mutate({
        variables: data
      })
    })
  })  
);


export default connect(null, {cancelRetryPayment})(withQueries(RetryPaymentFormContainer));